// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-row {
  background-color: #e6f4ff !important;
  pointer-events: none;
}

.hover-row:hover {
  background-color: #f5f5f5 !important;
  cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/views/ProjectHome/ListFileAndPermission/FileDetailsView/RevisionTable/style.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB","sourcesContent":[".selected-row {\r\n  background-color: #e6f4ff !important;\r\n  pointer-events: none;\r\n}\r\n\r\n.hover-row:hover {\r\n  background-color: #f5f5f5 !important;\r\n  cursor: pointer;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
